import React from "react";
import { Link } from "react-router-dom";
import { FolderHeart, FileCheck2, ArrowRight } from "lucide-react";
import MetaBridgePage from "./MetaBridgePage";

export default function ServiceDmp() {
  return (
    <>
      <MetaBridgePage
      title="MetaBridge DMP : Mon espace santé · MetaConnect"
      metaDescription="Alimenter et consulter le Dossier Médical Partagé (Mon espace santé) depuis votre logiciel métier. Connecteur DMP conforme aux référentiels ANS."
      canonical="/services/dmp"
      eyebrow="DMP / Mon espace santé"
      h1="Alimentez le DMP de Mon espace santé depuis votre logiciel."
      intro="MetaBridge DMP permet à votre logiciel métier d'alimenter et de consulter le Dossier Médical Partagé du patient sur Mon espace santé, en conformité avec les référentiels nationaux."
      icon={<FolderHeart size={26} />}
      testIdSlug="dmp"
      bullets={[
        "Alimentation automatique du DMP depuis votre logiciel",
        "Consultation du DMP du patient en quelques clics",
        "Authentification du professionnel via Pro Santé Connect",
        "Identification patient avec INS qualifiée",
        "Conforme à la doctrine technique ANS 2026",
        "Hébergement HDS · sans stockage de données chez vous",
      ]}
      details={[
        { title: "Standards", desc: "CDA R2, profils IHE XDS.b, CI-SIS Documents." },
        { title: "Sécurité", desc: "PSC obligatoire pour pros, journalisation conforme PGSSI-S." },
        { title: "Cas d'usage", desc: "Dépôt de comptes-rendus, ordonnances, résultats biologie, imageries." },
      ]}
      useCases={[
        { tag: "Ville", title: "Cabinet libéral", desc: "Le médecin dépose son CR de consultation dans le DMP en un clic depuis son logiciel." },
        { tag: "Hôpital", title: "Établissement", desc: "Le SIH pousse automatiquement les CRH et examens à la sortie du patient." },
        { tag: "Biologie", title: "Laboratoire", desc: "Les résultats sont déposés au DMP dès validation biologique." },
        { tag: "Imagerie", title: "Cabinet radio", desc: "Les CR d'imagerie et liens vers les examens sont versés au DMP." },
      ]}
      faq={[
        { q: "Faut-il une carte CPS pour utiliser MetaBridge DMP ?", a: "Oui, l'authentification du professionnel se fait via Pro Santé Connect (e-CPS ou carte CPS/CPx)." },
        { q: "Le DMP devient-il automatiquement consultable par le patient ?", a: "Oui, chaque document déposé est immédiatement visible par le patient dans son espace Mon espace santé." },
        { q: "Quels documents peut-on déposer ?", a: "Comptes-rendus médicaux, ordonnances, résultats de biologie, examens d'imagerie, lettres de liaison, etc." },
      ]}
    />

      {/* ===== Bannière : parcours d'homologation CNDA ===== */}
      <section className="hex-soft py-16 lg:py-20" data-testid="dmp-cnda-banner">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="mc-card p-8 lg:p-10 relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-[280px] h-[280px] rounded-full pointer-events-none"
                 style={{ background: "radial-gradient(circle, rgba(110,231,197,0.18), transparent 60%)" }} />
            <div className="relative grid lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-8">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[11px] uppercase tracking-[0.22em] border border-emerald-200 bg-[rgba(110,231,197,0.06)] text-emerald-600">
                  <FileCheck2 size={13} /> Documentation institutionnelle
                </div>
                <h2 className="font-display text-[#0F2B5B] text-2xl sm:text-3xl lg:text-[34px] font-semibold leading-tight mt-4">
                  Vous êtes éditeur de logiciel santé&nbsp;? <br className="hidden sm:block" />
                  Découvrez le parcours d&apos;<span className="text-[#0F2B5B]">homologation CNDA</span>.
                </h2>
                <p className="mt-4 text-[14.5px] text-[#475569] leading-relaxed max-w-2xl">
                  Profils DMP, transactions <strong className="text-[#0F2B5B]">TD0.x à TD3.x</strong>, matrice
                  des droits, identité INS, preuves attendues&hellip; une présentation complète des étapes
                  CNDA pour préparer le référencement de votre LPS.
                </p>
              </div>
              <div className="lg:col-span-4 flex lg:justify-end">
                <Link to="/services/dmp/certification-cnda"
                      className="btn-primary px-6 py-3.5 rounded-full text-[14px] font-medium inline-flex items-center gap-2"
                      data-testid="dmp-cnda-cta">
                  Voir la présentation <ArrowRight size={16} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
